import { Component, Input, OnInit } from '@angular/core';
import { PDFGenerator } from '@ionic-native/pdf-generator/ngx';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.page.html',
  styleUrls: ['./invoice.page.scss'],
})
export class InvoicePage implements OnInit {
  @Input()orderData:any;
  o_id: any;
  tot: any;
  res_name: any;
  orders=[];
  schedule_time: any;
  instructions: any;
  time: any;
  total_price_with_extras: number;
  total_price: number;
  userChoices: any = []
  categories: any;
  category: any;
  object: any;
  payment_type:any;
  content: string;
// node
  constructor(private pdfGenerator:PDFGenerator,
    public globals:GlobalVariable,
    private modalController:ModalController,
    
   ) { }

  ngOnInit() {
  }
  ionViewWillEnter(){
    console.log(this.orderData)
     this.orders = this.orderData.data
        this.time =this.orderData.time
        this.instructions = this.orderData.instructions
        console.log(this.instructions)
        this.schedule_time = this.orderData.schedule_time
        this.res_name = this.orderData.res
        this.tot = this.orderData.tot
        this.o_id = this.orderData.o_id
        this.payment_type = this.orderData.p_type
        console.log("payment type",this.payment_type)
        // this.node = document.getElementById('print');
  }
  downloadInvoice() {
    this.content = document.getElementById('invoice').innerHTML;
    let options = {
      documentSize: 'A4',
      type: 'share',
      // landscape: 'portrait',
      fileName: "Order-Invoice-"+this.o_id+".pdf"
    };
    this.pdfGenerator.fromData(this.content, options)
      .then((base64) => {
        console.log('OK', base64);
      }).catch((error) => {
        console.log('error', error);
      });

  }
  close(){
    this.modalController.dismiss()
  }
}
